<mulo-prologue>
    <mulo-centered-block-layout>
        <h1>
            @switch (indexKey) {
                @case ('researchersIndex') {
                    <mat-icon svgIcon="account" muloSvgViewbox></mat-icon>
                    <span>{{ 'esploro.research.conf.research.portal.label.prefix.profileLink' | translate }}</span>
                }
                @case ('assetsIndex') {
                    <mat-icon class="mat-icon-rtl-mirror" svgIcon="asset-thumbnail-sm" muloSvgViewbox></mat-icon>
                    <span>{{ 'esploro.research.conf.research.portal.label.prefix.portalLink' | translate }}</span>
                }
            }
        </h1>
    </mulo-centered-block-layout>
</mulo-prologue>
@if (loading) {
    <mulo-loading-slate></mulo-loading-slate>
} @else if ((indexData | keyvalue).length === 0) {
    <mulo-centered-block-layout>
        <div class="error-wrap">
            <img src="./assets/images/unexpected-error.svg" alt="" class="margin-sm" />
            <p class="error-msg">{{ 'research.search.results.assets.error' | translate }}</p>
        </div>
    </mulo-centered-block-layout>
} @else {
    <mulo-centered-block-layout>
        <nav>
            <ol>
                @for (section of indexData | keyvalue; track section) {
                    @if (section.key !== 'OTHER') {
                        <li>
                            @if (section.value.length > 0) {
                                <a [routerLink]="['../', section.key]" queryParamsHandling="preserve">{{
                                    section.key
                                }}</a>
                            } @else {
                                <span>{{ section.key }}</span>
                            }
                        </li>
                    }
                }
                @if (indexData?.['OTHER'] && indexData?.['OTHER'].length > 0) {
                    <li>
                        <a routerLink="../OTHER" queryParamsHandling="preserve">?</a>
                    </li>
                }
            </ol>
        </nav>
        <div class="back-to-top" muloSticky (muloStickyStuck)="bttStuck = $event" [class.is-stuck]="bttStuck">
            @if (bttStuck) {
                <a
                    @opacityInAnimation
                    @opacityOutAnimation
                    routerLink="."
                    queryParamsHandling="preserve"
                    mat-fab
                    extended
                    class="has-shadow"
                >
                    <mat-icon svgIcon="arrow-up"></mat-icon>
                    {{ 'research.portal.fulldisplay.backToTopButton' | translate }}
                </a>
            }
        </div>
        <main>
            @if (indexData?.[indexIdx]; as section) {
                <h2 [id]="indexIdx">{{ indexIdx }}</h2>
                <ol class="index-list">
                    @for (item of section; track item) {
                        <li>
                            @if (item.split(delimiter); as nameUrlPair) {
                                <a class="hasnt-color" [href]="nameUrlPair[1]">{{ nameUrlPair[0] }}</a>
                            }
                        </li>
                    }
                </ol>
            }
        </main>
    </mulo-centered-block-layout>
}
